import React, { useImperativeHandle } from 'react';
import { useTheme } from '../contexts/ThemeContext';

import { Box, Button, Layer, Spinner, Text } from 'grommet';

const EmbeddingIcon = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState();
  const [isDataLoaded, setIsDataLoaded] = React.useState(false);
  const { theme } = useTheme();

  const EmbeddingStart = (e) => {
    setOpen(e);
  };

  const EmbeddingStop = () => {
    setOpen(undefined);
  }

  useImperativeHandle(ref, (e) => ({
    EmbeddingStart(e) {
      EmbeddingStart(e)
    }
  }))

  return (
    <>
      {open && (
        // class and theme can match loading since they show the same detail
        <Layer className={`${theme} loadingPane`} style={{borderRadius: '12px'}}>
          <Box
            style={{borderRadius: '12px'}}
            className={`${theme} loadingPane`}
            align="center"
            justify="center"
            gap="small"
            direction="row"
            alignSelf="center"
            pad="large"
          >
            <Spinner />
            <Text style={{fontSize: 24, fontFamily: "MetricHPE-Web-Regular"}}>Creating embedding...</Text>

          </Box>
        </Layer>
      )}
    </>
  );
});

export default EmbeddingIcon;